"use client";

import { SliderItemProps } from "@/data/Static/sliderdata";
import HeroSlider from "./HeroSlider";

export default function HeroSliderWrapper({ data, time }: { data: SliderItemProps[]; time: number }) {
  return <HeroSlider data={data} time={time} />;
}
